import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MapEditorLayer } from "../../types/mapEditorTypes";

type Props = {
    data: MapEditorLayer;
};

export default function MapEditorLayerDisplay({ data }: Props) {
    const { t } = useTranslation("mapEditor");

    return (
        <Stack rowGap={2}>
            <Stack>
                <Typography variant="caption">{t("mapEditorLayerDetails.labelName")}</Typography>
                <Typography>{data.name}</Typography>
            </Stack>

            <Stack direction="row" spacing={1} alignItems="center">
                <Stack flex={1}>
                    <Typography variant="caption">{t("mapEditorLayerDetails.labelStyle")}</Typography>
                    <Typography>{data.style}</Typography>
                </Stack>
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        backgroundColor: data.color,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                    }}
                />
            </Stack>
        </Stack>
    );
}
